<div class="badge" [@bounce]="animeState">{{count}}</div>
